module.exports = __webpack_public_path__ + "img/imagen3.c8d53a3d.png";